module.exports = __webpack_public_path__ + "img/fb.a8d88786.png";